import { LN2, styled, withStyle } from '@olxeu-jobs/ui';
import { Paper } from '../paper';
import type { SidebarWidgetVariant } from './types';

export const Wrapper = withStyle<typeof Paper, { $variant: SidebarWidgetVariant }>(
  Paper,
  ({ $theme, $variant }) => ({
    position: 'relative',
    color: $theme.colors['text-global-secondary'],
    ...($variant === 'highlight' && {
      backgroundColor: $theme.colors['background-brand-notification-neutral'],
      color: $theme.colors['text-brand-primary'],
    }),
  }),
);

export const ContentWrapper = styled<'div', { $loading: boolean }>(
  'div',
  ({ $theme, $loading }) => ({
    visibility: $loading ? 'hidden' : undefined,
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.space['16'],
  }),
);

export const Title = withStyle(LN2, () => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: 0,
  marginBottom: 0,
}));
